import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '@env/environment';
import {
    NotificacionWebCount,
    NotificacionWebOpenResult,
    NotificacionWebPage,
    TipoNotificacionWebOption
} from '@app/domain/notificacion-web';

@Injectable({
    providedIn: 'root'
})
export class NotificacionWebService {

    private readonly baseUrl = environment.endpointApi;
    private readonly hiddenLoaderHeaders = {hideLoader: 'S'};

    constructor(private http: HttpClient) {
    }

    findAll(pageNumber = 0, perPage = 10): Observable<NotificacionWebPage> {
        const params = new HttpParams()
            .set('pageNumber', pageNumber.toString())
            .set('perPage', perPage.toString());
        return this.http.get<NotificacionWebPage>(`${this.baseUrl}/notificaciones`, {
            params,
            headers: this.hiddenLoaderHeaders
        });
    }

    findHistory(pageNumber = 0,
                perPage = 10,
                fechaDesde?: Date,
                fechaHasta?: Date): Observable<NotificacionWebPage> {
        let params = new HttpParams()
            .set('pageNumber', pageNumber.toString())
            .set('perPage', perPage.toString());
        if (fechaDesde) {
            params = params.set('fechaDesde', this.formatDate(fechaDesde));
        }
        if (fechaHasta) {
            params = params.set('fechaHasta', this.formatDate(fechaHasta));
        }
        return this.http.get<NotificacionWebPage>(`${this.baseUrl}/notificaciones/historial`, {
            params,
            headers: this.hiddenLoaderHeaders
        });
    }

    countUnopened(): Observable<NotificacionWebCount> {
        return this.http.get<NotificacionWebCount>(`${this.baseUrl}/notificaciones/sin-abrir/count`, {
            headers: this.hiddenLoaderHeaders
        });
    }

    findTypes(): Observable<TipoNotificacionWebOption[]> {
        return this.http.get<TipoNotificacionWebOption[]>(`${this.baseUrl}/notificaciones/tipos`);
    }

    markAsOpened(id: number): Observable<NotificacionWebOpenResult> {
        return this.http.patch<NotificacionWebOpenResult>(`${this.baseUrl}/notificaciones/${id}/abierta`, null, {
            headers: this.hiddenLoaderHeaders
        });
    }

    private formatDate(date: Date): string {
        const day = date.getDate().toString().padStart(2, '0');
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        return `${day}-${month}-${date.getFullYear()}`;
    }
}
